import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function RecommendSection() {
  const recommended = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <section className="py-8 md:py-10" aria-labelledby="recommend-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <h2 id="recommend-title" className="text-lg md:text-xl font-heading text-foreground-900">
            编辑推荐
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
          {recommended.map((comic) => {
            const cat = categories.find((c) => c.slug === comic.category);
            return (
              <ComicCard
                key={comic.id}
                slug={comic.slug}
                title={comic.title}
                author={comic.author}
                cover={comic.cover}
                category={comic.category}
                categoryName={cat?.name || ''}
                status={comic.status}
                rating={comic.rating}
                views={comic.views}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}